import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchShowcaseProjectFile extends BaseModel {
  static override constructorName = 'ResearchShowcaseProjectFile'

  title: string = ''
  file: string = ''
  'file_type': string = ''
  'file_size': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchShowcaseProjectFile)
